module.exports = __webpack_public_path__ + "img/ybheader.2d6c09fc.jpg";